
/*
    Display for an individual quarterly report record,
    with media query differences for screen widths
*/

import React from "react";
import Media from "react-media";

import DataItem from "../Components/DataItem";

export default class ReportQuarterlyData extends React.Component {
    render() {

        const {data} = this.props;

        return (
            <>
            <Media query="(max-width: 811px)">
                <div className="data" style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 3fr 3fr 4fr 3fr 3fr",
                    gridGap: "4px",
                    padding: "8px 8px",
                    justifyItems: "flex-start",
                    alignItems: "center"
                }}>
                    <div>Route: <DataItem val={data.ReportSubject} /></div>
                    <div>Total: <DataItem val={data.Total} /></div>
                    <div>Sched Late: <DataItem val={data.SchedLate} /></div>
                    <div>Sched OT%: <DataItem val={data.SchedPercentage} /></div>
                    <div>Runs Late: <DataItem val={data.RunsLate} /></div>
                    <div>Runs OT%: <DataItem val={data.RunPercentage} /></div>
                    <div>PASS</div>
                    <div>Boarding: <DataItem val={data.Passengers} /></div>
                    <div>Arriving: <DataItem val={data.Passoacount} /></div>
                    <div>Getting Off: <DataItem val={data.Passgocount} /></div>
                    <div>Left Behind: <DataItem val={data.Passlbcount} /></div>
                    <div>Departing: <DataItem val={data.Passodcount} /></div>
                </div>
            </Media>
            <Media query="(min-width: 812px)">
                <div className="data" style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 2fr 1fr 2fr 2fr 2fr 2fr 2fr",
                    gridGap: "4px",
                    padding: "8px 0",
                    justifyItems: "center",
                    alignItems: "center",
                    marginBottom: "6px"
                }}>
                    <div><DataItem val={data.ReportSubject} /></div>
                    <div><DataItem val={data.Total} /></div>
                    <div><DataItem val={data.SchedLate} /></div>
                    <div><DataItem val={data.SchedPercentage} /></div>
                    <div><DataItem val={data.RunsLate} /></div>
                    <div><DataItem val={data.RunPercentage} /></div>
                    <div></div>
                    <div><DataItem val={data.Passengers} /></div>
                    <div><DataItem val={data.Passoacount} /></div>
                    <div><DataItem val={data.Passgocount} /></div>
                    <div><DataItem val={data.Passlbcount} /></div>
                    <div><DataItem val={data.Passodcount} /></div>
                </div>
            </Media>
            </>
        );
    }
}